<form #form="ngForm">
    <ng-container *ngIf="review">
        <ui-card>
            <app-segment-header title="performance.bulk-review.reviewDetails"></app-segment-header>
            <div class="app-grid">
                <mat-form-field class="columns-6 small-columns-12">
                    <mat-label>{{ 'performance.bulk-review.title' | translate }}</mat-label>
                    <input
                        matInput
                        type="text"
                        name="title"
                        required
                        placeholder="{{ 'performance.bulk-review.enterATitleForYourReview' | translate }}"
                        #title="ngModel"
                        [(ngModel)]="review.title"
                    />
                    <mat-error *ngIf="title.invalid">{{ title.errors | formErrors }}</mat-error>
                </mat-form-field>
            </div>
            <div class="app-grid">
                <mat-form-field class="columns-6 small-columns-12">
                    <mat-label>{{ 'performance.bulk-review.reviewInstructions' | translate }}</mat-label>
                    <textarea
                        matInput
                        type="text"
                        name="instruction"
                        placeholder="{{ 'performance.bulk-review.enterInstruction' | translate }}"
                        #title="ngModel"
                        [(ngModel)]="review.instruction"
                        rows="9"
                    ></textarea>
                    <mat-hint>{{ 'performance.bulk-review.reviewDescription' | translate }}</mat-hint>
                    <mat-error *ngIf="title.invalid">{{ title.errors | formErrors }}</mat-error>
                </mat-form-field>
            </div>

            <div class="app-grid">
                <mat-form-field class="columns-6 small-columns-12 margin-top-2">
                    <mat-label appRemoveAriaOwns>{{ 'performance.bulk-review.frequency' | translate }}</mat-label>
                    <mat-select
                        name="reoccuring"
                        [(ngModel)]="review.reoccuring"
                        (selectionChange)="clearSelectedReviewPeriod()"
                    >
                        <mat-option value="">{{
                            'performance.bulk-review.frequencyOptions.selectAnOption' | translate
                        }}</mat-option>
                        <mat-option value="never">{{
                            'performance.bulk-review.frequencyOptions.once' | translate
                        }}</mat-option>
                        <mat-option value="weekly">{{
                            'performance.bulk-review.frequencyOptions.weekly' | translate
                        }}</mat-option>
                        <mat-option value="monthly">{{
                            'performance.bulk-review.frequencyOptions.monthly' | translate
                        }}</mat-option>
                        <mat-option value="quarterly">{{
                            'performance.bulk-review.frequencyOptions.quarterly' | translate
                        }}</mat-option>
                        <mat-option value="semiannually">{{
                            'performance.bulk-review.frequencyOptions.semiannually' | translate
                        }}</mat-option>
                        <mat-option value="annually">{{
                            'performance.bulk-review.frequencyOptions.annually' | translate
                        }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="app-grid">
                <mat-form-field class="columns-6 small-columns-12">
                    <mat-label appRemoveAriaOwns>{{ 'performance.bulk-review.reviewPeriod' | translate }}</mat-label>
                    <mat-select
                        name="reviewPeriod"
                        #reviewPeriod="ngModel"
                        [(ngModel)]="selectedReviewPeriod"
                        required
                        (selectionChange)="reviewPeriodSelection($event?.value)"
                        placeholder="{{ 'performance.bulk-review.frequencyOptions.selectAnOption' | translate }}"
                    >
                        <ng-container *ngIf="reviewPeriods[review.reoccuring]">
                            <mat-option
                                *ngFor="let reviewPeriod of reviewPeriods[review.reoccuring]; index as i"
                                [value]="i"
                                >{{ reviewPeriod.start | appDate: 'MMM dd, yyyy' }} -
                                {{ reviewPeriod.end | appDate: 'MMM dd, yyyy' }}</mat-option
                            >
                        </ng-container>

                        <mat-option [value]="'custom'">{{
                            'performance.bulk-review.selectATimeframe' | translate
                        }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <ng-container *ngIf="reviewPeriod.value === 'custom'">
                    <mat-form-field class="columns-4 small-columns-12">
                        <mat-label
                            >{{ 'performance.bulk-review.timeFrameThisReviewWillBeBasedOn' | translate }} *</mat-label
                        >
                        <mat-date-range-input [rangePicker]="picker">
                            <input
                                name="periodStart"
                                matStartDate
                                [(ngModel)]="review.periodStart"
                                [required]="reviewPeriod.value === 'custom'"
                            />
                            <input
                                name="periodEnd"
                                matEndDate
                                [(ngModel)]="review.periodEnd"
                                [required]="reviewPeriod.value === 'custom'"
                            />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker">
                            <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                        </mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </ng-container>
            </div>
        </ui-card>

        <ui-card>
            <app-segment-header title="performance.bulk-review.reviewStartAndDueDates"></app-segment-header>

            <div class="app-grid">
                <ui-date-picker
                    label="{{ 'performance.bulk-review.startDate' | translate }}"
                    name="scheduleAt"
                    #scheduleAt="ngModel"
                    class="columns-6 small-columns-12"
                    [ngModel]="review.scheduleAt | appDate: 'yyyy-MM-dd'"
                    (ngModelChange)="review.scheduleAt = $event"
                    placeholder="{{ 'performance.bulk-review.selectAStartDate' | translate }}"
                    required
                ></ui-date-picker>
            </div>

            <div class="app-grid">
                <ui-date-picker
                    label="{{ 'performance.bulk-review.dueDate' | translate }}"
                    name="dueAt"
                    #dueAt="ngModel"
                    class="columns-6 small-columns-12"
                    [ngModel]="review.dueAt | appDate: 'yyyy-MM-dd'"
                    (ngModelChange)="review.dueAt = $event"
                    placeholder="{{ 'performance.bulk-review.selectADueDate' | translate }}"
                    required
                ></ui-date-picker>
            </div>
        </ui-card>

        <ui-card>
            <div class="app-grid" [class.loading]="isLoading">
                <app-segment-header title="performance.bulk-review.selectTemplate.reviewTemplate"></app-segment-header>
                <mat-form-field class="columns-4" *ngIf="templates?.length">
                    <mat-label appRemoveAriaOwns>{{
                        'performance.bulk-review.selectTemplate.reviewTemplate' | translate
                    }}</mat-label>
                    <input
                        #template="ngModel"
                        name="template"
                        type="text"
                        placeholder="{{ 'performance.bulk-review.selectTemplate.selectOrSearchTemplate' | translate }}"
                        required
                        matInput
                        [matAutocomplete]="auto"
                        [templateValidator]="templates"
                        [ngModel]="searchValue"
                        (ngModelChange)="filterTemplates($event)"
                        (focus)="filterTemplates(searchValue)"
                    />

                    <mat-autocomplete
                        autoActiveFirstOption
                        #auto="matAutocomplete"
                        (optionSelected)="onOptionSelected($event)"
                    >
                        <mat-option
                            *ngFor="let template of filteredTemplates"
                            [value]="template.id"
                            [disabled]="!template.isValid"
                        >
                            <div class="template-option">
                                <span>
                                    {{ template.name }}
                                </span>
                                <ui-badge *ngIf="!template.isValid" class="margin-left-auto margin-y-auto">{{
                                    'performance.bulk-review.selectTemplate.incomplete' | translate | uppercase
                                }}</ui-badge>
                            </div>
                        </mat-option>
                    </mat-autocomplete>

                    @if (template.invalid) {
                        <mat-error>
                            @if (template.errors?.required) {
                                {{ 'performance.bulk-review.selectTemplate.fieldRequired' | translate }}
                            } @else if (template.errors?.invalidTemplate) {
                                {{ 'performance.bulk-review.selectTemplate.invalidTemplateError' | translate }}
                            }
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        </ui-card>

        <ui-card>
            <div class="app-grid">
                <app-segment-header title="performance.bulk-review.responseAccess.title"></app-segment-header>
                <div>{{ 'performance.bulk-review.responseAccess.whoCanHaveAccessToReviewResponses' | translate }}</div>

                <div class="ui divider"></div>

                <div class="padding-bottom-2">
                    <div class="padding-bottom-1">
                        <strong>{{ 'performance.bulk-review.responseAccess.adminsLabel' | translate }}</strong>
                    </div>
                    <div>
                        <p>
                            {{ 'performance.bulk-review.responseAccess.adminsCanSeeResponsesNoMatterWhat' | translate }}
                        </p>
                    </div>
                </div>

                <div class="padding-bottom-2">
                    <div class="padding-bottom-1">
                        <strong>{{ 'performance.bulk-review.responseAccess.directManagersLabel' | translate }}</strong>
                        <ui-info
                            class="margin-left-1"
                            text="performance.bulk-review.responseAccess.directManagerSettingTooltip"
                        ></ui-info>
                    </div>
                    <mat-radio-group
                        name="viewResultsBeforeCompletion"
                        class="vertical"
                        [(ngModel)]="review.viewResultsBeforeCompletion"
                    >
                        <mat-radio-button class="margin-bottom-1" [value]="false">{{
                            'performance.bulk-review.responseAccess.directManagersCanSeeResponsesOnceCompleted'
                                | translate
                        }}</mat-radio-button>
                        <mat-radio-button [value]="true">{{
                            'performance.bulk-review.responseAccess.directManagersCanAlwaysSeeResponses' | translate
                        }}</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="padding-bottom-2">
                    <div class="padding-bottom-1">
                        <strong>{{
                            'performance.bulk-review.responseAccess.revieweesAndOtherParticipants' | translate
                        }}</strong>
                    </div>

                    <div class="app-grid padding-bottom-1">
                        <mat-checkbox
                            [(ngModel)]="review.subjectCanViewResults"
                            name="subjectCanViewResults"
                            #subjectCanViewResults="ngModel"
                        >
                            <span *ngIf="review.subject?.fullName">{{
                                'performance.bulk-review.responseAccess.makeResultsVisibleToRevieweeName'
                                    | translate: { revieweeName: review.subject?.fullName }
                            }}</span>

                            <span *ngIf="!review.subject?.fullName">{{
                                'performance.bulk-review.responseAccess.makeResultsVisibleToReviewee' | translate
                            }}</span>
                        </mat-checkbox>
                        <mat-error *ngIf="subjectCanViewResults?.errors">{{
                            subjectCanViewResults?.errors | formErrors
                        }}</mat-error>
                    </div>
                    <div class="app-grid">
                        <mat-checkbox
                            [(ngModel)]="review.participantsCanViewResults"
                            name="participantsCanViewResults"
                            #participantsCanViewResults="ngModel"
                            >{{
                                'performance.bulk-review.responseAccess.makeResultsVisibleToOtherParticipants'
                                    | translate
                            }}</mat-checkbox
                        >
                        <mat-error *ngIf="participantsCanViewResults?.errors">{{
                            participantsCanViewResults?.errors | formErrors
                        }}</mat-error>
                    </div>
                </div>
            </div>
        </ui-card>
    </ng-container>
</form>
